import { useAgreementOpening } from '~/composables/useAgreementOpening'
import { useLogger } from '~/composables/useLogger'
import { usePresentationTranslator } from '~/composables/usePresentationTranslator'
import { isUserAgreementOfType } from '~/composables/isUserAgreementOfType'
import { useLegalAgreementLookup } from '~/composables/useLegalAgreementLookup'
import type { UserAgreement } from '~/composables/UserAgreement'
import type { UserAgreementType } from '~/composables/UserAgreementType'

/** Opens the user's Terms & Conditions or Privacy Policy in place; a failed load is toasted and stays closed. */
export const useUserAgreementModal = () => {
  const { loadCurrentAgreement } = useLegalAgreementLookup()
  const toast = useToast()
  const t = usePresentationTranslator()
  const logger = useLogger('useUserAgreementModal')

  return useAgreementOpening<UserAgreement, [type: UserAgreementType]>({
    load: (type) => loadCurrentAgreement({ type }, isUserAgreementOfType(type)),
    onAbsent: () => {
      toast.error(t('common.legalAgreement.errors.load'))
    },
    onLoadFailure: (error) => {
      logger.error('open', { error })
      toast.error(t('common.legalAgreement.errors.load'))
    }
  })
}
